export default {
  en: {
    add: 'Add',
    vehicleAlreadyExists: 'Vehicle already exists',
    addVehicleToPrivateList:
      "Do you want to add the vehicle to my vehicles? Notice: you can't edit this vehicle's details",
    newVehicleWithLicensePlate: 'New vehicle with licenseplate {{licensePlate}}',
    addVehicleToPrivateListWithLicensePlate: 'Add vehicle {{licensePlate}} to my vehicles',
    addAccessRightForVehicleWithLicensePlate: 'Add access right for vehicle {{licensePlate}}',
    vehicleAddSuccess: 'Vehicle added to my vehicles',
    vehicleAddErr: 'Something went wrong, could not add vehicle to my vehicles',

    approver: 'Approver',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    country: 'Country',
    state: 'Status',
    type: 'Type',
    save: 'Save',
    next: 'Next',
    properies: 'Properies',
    accessTime: 'Access time',
    message: 'Message',
    validFrom: 'From',
    validUntil: 'Until',
    createdOn: 'Created on',
    createdBy: 'Created by',
    lastSeenOn: 'Last seen',
    modifiedOn: 'Last modified',
    owner: 'Owner',
    iAmTheOwner: 'Vehicle is owned by your organisation',
    externalOwner: 'Vehicle is owned by another organisation',
    licensePlate: 'License plate',
    requests: 'Requests',
    newRequest: 'New request',
    addRequest: 'Add request',
    accessLogs: 'Access Logs',
    accessLogDetails: 'Access log details',
    accessRights: 'access right',
    accessRights_plural: 'My access rights',
    myAccessRights: 'My access rights',
    allAccessRights: 'All access rights',
    accessRightDetails: 'Access right details',
    vehicleDetails: 'Vehicle details',
    properties: 'Properties',
    accessLogFetchErr: 'Something went wrong, could not fetch access log',
    vehicleCreateErr: 'Something went wrong, could not create vehicle',
    vehicleCreateSuccess: 'Vehicle created',
    vehicleFetchErr: 'Something went wrong, could not fetch vehicle',
    vehicleDeleteErr: 'Something went wrong, could not delete vehicle',
    vehicleDeleteSuccess: 'Vehicle deleted',
    vehicleUpdateErr: 'Something went wrong, could not update vehicle',
    vehicleUpdateSuccess: 'Vehicle updated',
    addVehicle: 'Add vehicle',
    editVehicle: 'Edit vehicle',
    newVehicle: 'New vehicle',
    deleteVehicle: 'Delete vehicle',
    noVehicles: 'No vehicles found',
    allVehicles: 'All vehicles',
    vehicles: 'Vehicles',
    myVehicles: 'My vehicles',
    hasActiveAccessRights: 'Access',
    validActiveAccessRight: 'Yes',
    invalidActiveAccessRight: 'No',
    accessRightFetchErr: 'Something went wrong, could not fetch access right',
    accessRightCreateErr: 'Something went wrong, could not create access right',
    accessRightCreateSuccess: 'Access right created',
    accessRightDeleteErr: 'Something went wrong, could not delete access right',
    accessRightDeleteSuccess: 'Access right deleted',
    accessRightUpdateErr: 'Something went wrong, could not update access right',
    accessRightUpdateSuccess: 'Access right updated',
    accessRightRequestErr: 'Something went wrong, could not request access right',
    accessRightRequestSuccess: 'Access right requested',
    addAccessRight: 'Add access right',
    requestAccessRight: 'Request access right',
    requestAccessRightForVehicle: 'Request access right for vehicle {{licensePlate}}',
    newAccessRight: 'New access right',
    newAccessRightForVehicle: 'New access right for vehicle {{licensePlate}}',
    editAccessRight: 'Edit access right',
    editVehicleWithLicensePlate: 'Edit vehicle {{licensePlate}}',
    withLicenseplate: 'with licenseplate {{licensePlate}}',
    editAccessRightForVehicle: 'Edit access right for vehicle {{licensePlate}}',
    deleteAccessRight: 'Delete access right',
    noAccessRights: 'No access rights found',
    noAccessLogs: 'No access logs found',
    deleteVehicleConfirmation: 'Are you sure you want to delete this vehicle?',
    deleteAccessRightConfirmation: 'Are you sure you want to remove this access right?',
    selectVehicleErr: 'Please select a vehicle',
    selectVehicleTypeErr: 'Please select a vehicle type',
    selectCountryErr: 'Please select a country',
    selectStateErr: 'Please select a state',
    noOwnerErr: 'Please enter an owner',
    chooseDateErr: 'Please choose a date',
    dateOrderErr: 'Please choose a date after the from-date',
    noLicensePlateErr: 'Please enter a license plate',
    createNewVehicle: 'Create new vehicle',
    andXMore: 'And {{x}} more ...',
    onPremiseOrganisation: 'On premise company',
    offPremiseOrganisation: 'Off premise company',
    licensePlateContainsSpecialChars:
      'Special characters will be removed when the vehicle is saved',
    // Backend error messages
    ACCESSRIGHT_CREATE_INVALID_STATE_DELETED:
      "Access rights may not be created with the 'Deleted' state.",
    ACCESSRIGHT_CREATE_INVALID_STATE_NEW: "Access rights may not be created with the 'New' state.",
    ACCESSRIGHT_UPDATE_INVALID_STATE_DELETED:
      "Access rights may not be updated to the 'Deleted' state.",
    ACCESSRIGHT_UPDATE_INVALID_STATE_NEW: "Access rights may not be updated to the 'New' state.",
    AGREEMENT_ALREADY_EXISTS: 'Agreement already exists.',
    GENERAL_ON_PREMISE_NOT_FOUND: 'Host not found.',
    GENERAL_INVALID_DATE_ORDER: 'Make sure that start-date lies after end-date.',
    GENERAL_ORGANISATION_NOT_REGISTERED: 'Organisation has not yet registered.',
    VEHICLE_ALREADY_ON_PRIVATE_LIST: 'The vehicle was already on your list.',
    VEHICLE_CREATE_INVALID_TYPE_UNKNOWN: "Vehicles may not be created with the 'Unknown' type.",
    VEHICLE_HAS_NO_REGISTERED_OWNER: 'Owner has not yet registered; supply a name instead.',
    VEHICLE_LICENSEPLATE_ALREADY_EXISTS: 'License plate already exists.',
    VEHICLE_NOT_FOUND:
      'No vehicle with license plate {{0}} could be found. Create a new vehicle first.',
    VEHICLE_NOT_ON_PRIVATE_LIST: 'Vehicle not found in your private list.',
    MODEL_VALIDATION_ERRORS: 'One or more fields did not pass validation.',
    REQUIRES_REGISTRATION: 'Please register your organisation first.',
    VEHICLE_ALREADY_HAS_ACCESS_RIGHT: 'Vehicle already has an access right assigned.',

    // No access rights message
    noRightsMessage:
      '<1>Thank you for registering in our Vehicle DB App.</1><2>Your data will be validated by our team as soon as possible. You will receive an email notification, when the approval process is completed.</2><3>Full access to our app will be granted after the successful approval.</3><4>Thank you for your understanding.</4><5>Your Cargo Team</5><6>At Vienna Airport</6>',
    countryCode: 'Country',
    onPremiseAccessRights: 'access right',
  },
  de: {
    add: 'Hinzufügen',
    vehicleAlreadyExists: 'Fahrzeug ist bereits vorhanden',
    addVehicleToPrivateList:
      'Möchten Sie das Fahrzeug zur privaten Liste hinzufügen? Sie können die Fahrzeugdaten nicht bearbeiten.',
    newVehicleWithLicensePlate: 'Neues Fahrzeug mit Kennzeichen {{licensePlate}}',
    addVehicleToPrivateListWithLicensePlate:
      'Zur privaten Liste hinzufügen mit Kennzeichen {{licensePlate}}',
    addAccessRightForVehicleWithLicensePlate:
      'Berechtigung hinzufügen für Fahrzeug mit Kennzeichen: {{licensePlate}}',
    vehicleAddSuccess: 'Fahrzeug erfolgreich hinzugefügt',
    vehicleAddErr: 'Es ist ein Problem aufgetreten: das Fahrzeug konnte nicht erstellt werden',
    approver: 'Genehmiger',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    country: 'Land',
    state: 'Status',
    type: 'Art',
    save: 'Speichern',
    next: 'Weiter',
    properies: 'Eigenschaften',
    accessTime: 'Zugangszeit',
    message: 'Nachricht',
    validFrom: 'Von',
    validUntil: 'Bis zum',
    createdOn: 'Erstellt am',
    createdBy: 'Erstellt von',
    lastSeenOn: 'Zuletzt gesehen',
    modifiedOn: 'Zuletzt bearbeitet',
    owner: 'Inhaber',
    iAmTheOwner: 'Das Fahrzeug gehört unserer Organisation',
    externalOwner: 'Das Fahrzeug gehört einer anderen Organisation',
    licensePlate: 'Kennzeichen',
    requests: 'Anfragen',
    newRequest: 'Neue Anfrage',
    addRequest: 'Anfrage hinzufügen',
    accessLogs: 'Zufahrtsprotokolle',
    accessLogDetails: 'Zufahrtsprotokoll Details',
    accessRights: 'Berechtigungen',
    myAccessRights: 'Meine Zugangsrechte',
    allAccessRights: 'Alle Zugangsrechte',
    accessRightDetails: 'Berechtigungsdetails',
    vehicleDetails: 'Fahrzeugdetails',
    properties: 'Eigenschaften',
    accessLogFetchErr:
      'Es ist ein Problem aufgetreten: das  Zufahrtslog konnte nicht geladen werden',
    vehicleCreateErr: 'Es ist ein Problem aufgetreten: das  Fahrzeug konnte nicht erstellt werden',
    vehicleCreateSuccess: 'Fahrzeug erstellt',
    vehicleFetchErr: 'Es ist ein Problem aufgetreten: das  Fahrzeug konnte nicht geladen werden',
    vehicleDeleteErr: 'Etwas ist schief gelaufen, konnte das Fahrzeug nicht löschen',
    vehicleDeleteSuccess: 'Fahrzeug gelöscht',
    vehicleUpdateErr: 'Etwas ist schief gelaufen, konnte das  Fahrzeug nicht aktualisieren',
    vehicleUpdateSuccess: 'Fahrzeug aktualisiert',
    addVehicle: 'Fahrzeug hinzufügen',
    editVehicle: 'Fahrzeug bearbeiten',
    editVehicleWithLicensePlate: 'Fahrzeug bearbeiten mit Kfz-Kennzeichen {{licensePlate}}',
    withLicenseplate: 'Mit Kfz-Kennzeichen {{licensePlate}}',
    newVehicle: 'Neues Fahrzeug',
    deleteVehicle: 'Fahrzeug löschen',
    noVehicles: 'Keine Fahrzeuge gefunden',
    allVehicles: 'Alle Fahrzeuge',
    vehicles: 'Fahrzeuge',
    myVehicles: 'Meine Fahrzeuge',
    hasActiveAccessRights: 'Zugang',
    validActiveAccessRight: 'Ja',
    invalidActiveAccessRight: 'Nein',
    accessRightFetchErr:
      'Es ist ein Problem aufgetreten: die  Berechtigung konnte nicht geladen werden',
    accessRightCreateErr:
      'Es ist ein Problem aufgetreten: die  Berechtigung konnte nicht erstellt werden',
    accessRightCreateSuccess: 'Berechtigung erstellt',
    accessRightDeleteErr:
      'Es ist ein Problem aufgetreten: die  Berechtigung konnte nicht gelöscht werden',
    accessRightDeleteSuccess: 'Berechtigung gelöscht',
    accessRightUpdateErr:
      'Es ist ein Problem aufgetreten: die  Berechtigung konnte nicht aktualisiert werden',
    accessRightUpdateSuccess: 'Berechtigung aktualisiert',
    accessRightRequestErr:
      'Es ist ein Problem aufgetreten: die  Berechtigung konnte nicht abgefragt werden',
    accessRightRequestSuccess: 'Berechtigung abgefragt',
    addAccessRight: 'Berechtigung hinzufügen',
    requestAccessRight: 'Berechtigung anfordern',
    requestAccessRightForVehicle:
      'Berechtigung für Fahrzeuge {{licensePlate}} Kennzeichen anfordern',
    newAccessRight: 'Neue Berechtigung',
    newAccessRightForVehicle: 'Neue Berechtigung für Fahrzeug {{licensePlate}} Kennzeichen',
    editAccessRight: 'Berechtigung bearbeiten',
    editAccessRightForVehicle: 'Zugangsrecht für Fahrzeug {{licensePlate}} Kennzeichen bearbeiten',
    deleteAccessRight: 'Berechtigung löschen',
    noAccessRights: 'Keine Berechtigungen gefunden',
    noAccessLogs: 'Kein Einfahrtsprotokoll gefunden',
    deleteVehicleConfirmation: 'Sind Sie sicher, dass Sie dieses Fahrzeug löschen wollen?',
    deleteAccessRightConfirmation: 'Sind Sie sicher, dass Sie die Berechtigung entfernen wollen?',
    selectVehicleErr: 'Bitte wählen Sie ein Fahrzeug',
    selectVehicleTypeErr: 'Bitte wählen Sie einen Fahrzeugtyp',
    selectCountryErr: 'Bitte wählen Sie ein Land',
    selectStateErr: 'Bitte wählen Sie einen Staat',
    noOwnerErr: 'Bitte geben Sie einen Besitzer ein',
    chooseDateErr: 'Wählen Sie ein Datum',
    dateOrderErr: 'Bitte wählen Sie ein Datum nach dem Ab-Datum',
    noLicensePlateErr: 'Bitte geben Sie eine Kfz-Kennzeichen ein',
    createNewVehicle: 'Neues fahrzeug anlegen',
    andXMore: 'Und {{x}} mehr ...',
    onPremiseOrganisation: 'Interne firma',
    offPremiseOrganisation: 'Externe firma',
    licensePlateContainsSpecialChars: 'Sonderzeichen werden beim Speichern des Fahrzeugs entfernt',
    ACCESSRIGHT_CREATE_INVALID_STATE_DELETED:
      'Berechtigungen können nicht mit Status "gelöscht" erstellt werden',
    ACCESSRIGHT_CREATE_INVALID_STATE_NEW:
      'Berechtigungen können nicht mit Status "neu" erstellt werden',
    ACCESSRIGHT_UPDATE_INVALID_STATE_DELETED:
      'Berechtigungen können nicht auf den Status "gelöscht" aktualisiert werden',
    ACCESSRIGHT_UPDATE_INVALID_STATE_NEW:
      'Berechtigungen können nicht auf den Status "neu" aktualisiert werden',
    AGREEMENT_ALREADY_EXISTS: 'Abkommen ist bereits vorhanden.',
    GENERAL_ON_PREMISE_NOT_FOUND: 'Host nicht gefunden.',
    GENERAL_INVALID_DATE_ORDER: 'Stellen Sie sicher, dass das Enddatum nach dem Startdatum liegt.',
    GENERAL_ORGANISATION_NOT_REGISTERED: 'Die Organisation ist noch nicht registriert',
    VEHICLE_ALREADY_ON_PRIVATE_LIST: 'Das Fahrzeug war bereits auf Ihrer Liste.',
    VEHICLE_CREATE_INVALID_TYPE_UNKNOWN:
      'Fahrzeuge dürfen nicht mit der Type ‚Unbekannt‘ erstellt werden.',
    VEHICLE_HAS_NO_REGISTERED_OWNER:
      'Besitzer ist noch nicht registriert; bitte stattdessen einen Namen angeben.',
    VEHICLE_LICENSEPLATE_ALREADY_EXISTS: 'Kennzeichen ist bereits vorhanden',
    VEHICLE_NOT_FOUND:
      'Kein Fahrzeug mit Kfz-Kennzeichen {{0}} gefunden. Bitte erstellen Sie zuerst ein neues Fahrzeug.',
    VEHICLE_NOT_ON_PRIVATE_LIST: 'Fahrzeug nicht in Ihrer Privatliste gefunden.',
    MODEL_VALIDATION_ERRORS: 'Ein oder mehrere Felder haben die Überprüfung nicht bestanden.',
    REQUIRES_REGISTRATION: 'Bitte registrieren Sie Ihr Unternehmen zuerst.',
    VEHICLE_ALREADY_HAS_ACCESS_RIGHT: 'Fahrzeug hat bereits eine Berechtigung zugewiesen.',

    // No access rights message
    noRightsMessage:
      '<1>Vielen Dank für Ihre Registrierung für die Vehicle DB App.</1><2>Ihre eingegebenen Daten werden in den nächsten Tagen durch unser Team validiert. Sobald dieser Vorgang abgeschlossen ist, erhalten Sie eine Benachrichtigung per E-Mail.</2><3>Danach stehen Ihnen alle Funktionen der Applikation zur Verfügung.</3><4>Vielen Dank für Ihre Verständnis.</4><5>Ihr Cargo Team</5><6>Der Flughafen Wien AG</6>',
    countryCode: 'Land',
    onPremiseAccessRights: 'berechtigung',
  },
};
